var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19998 0.357917C8.93998 0.0979168 8.51998 0.0979168 8.25998 0.357917L4.99998 3.61125L1.73998 0.35125C1.47998 0.09125 1.05998 0.09125 0.79998 0.35125C0.53998 0.61125 0.53998 1.03125 0.79998 1.29125L4.05998 4.55125L0.79998 7.81125C0.53998 8.07125 0.53998 8.49125 0.79998 8.75125C1.05998 9.01125 1.47998 9.01125 1.73998 8.75125L4.99998 5.49125L8.25998 8.75125C8.51998 9.01125 8.93998 9.01125 9.19998 8.75125C9.45998 8.49125 9.45998 8.07125 9.19998 7.81125L5.93998 4.55125L9.19998 1.29125C9.45331 1.03792 9.45331 0.61125 9.19998 0.357917Z",
    fill: "#91919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3acea7c0490021807d66194c4aab3128.svg";
export { ForwardRef as ReactComponent };